import { shallowEqual, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export const useParsedUrlFilters = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const filtersFromURL = Object.fromEntries(searchParams.entries());
  let parsedFilters = {};
  Object.keys(filtersFromURL).forEach((entry) => {
    if (
      [
        'category',
        'brand',
        'offer_type',
        'offer_filter_type',
        'offer_value',
        'reward_offer',
        'platform',
      ].includes(entry)
    ) {
      if (entry === 'platform') {
        return (parsedFilters[entry] = filtersFromURL[entry]);
      } else if (
        typeof filtersFromURL[entry] === 'number' ||
        typeof filtersFromURL[entry] === 'string'
      ) {
        return (parsedFilters[entry] = filtersFromURL[entry]
          ?.split(',')
          ?.map(function (item) {
            if (
              entry === 'offer_type' ||
              entry === 'offer_value' ||
              entry === 'offer_filter_type'
            ) {
              return item;
            }
            return Number(item);
          }));
      }
    }
  });
  return parsedFilters;
};

export const useUrlFilters = ({ initFilters = false } = {}) => {
  const appliedFilters = useSelector(
    ({ appReducer }) => appReducer.appliedFilters,
    shallowEqual,
  );
  const tempAppliedFilters = useSelector(
    ({ appReducer }) => appReducer.tempAppliedFilters,
    shallowEqual,
  );
  const searchFilters = initFilters ? appliedFilters : tempAppliedFilters;
  Object.keys(searchFilters)?.forEach((key) => {
    if (
      searchFilters[key] === '' ||
      (Array.isArray(searchFilters[key]) && !searchFilters[key].length)
    ) {
      delete searchFilters[key];
    }
  });
  const searchParams = new URLSearchParams(searchFilters);
  return searchParams;
};

export const getUrlFilters = (filters) => {
  const searchFilters = { ...filters };
  Object.keys(searchFilters)?.forEach((key) => {
    if (
      searchFilters[key] === '' ||
      (Array.isArray(searchFilters[key]) && !searchFilters[key].length)
    ) {
      delete searchFilters[key];
    }
  });
  const searchParams = new URLSearchParams(searchFilters);
  return searchParams.toString();
};
